// extracted by mini-css-extract-plugin
export default {"container":"pos-credit-session-expired-error_container__f747d"};